const closeModal  = () => {

    //const pasapas = {close_id: "pasapasCrossClose", div_id: "modal-expo-pas-a-pas"};
    //addModalEvent(pasapas);
    const gardiensforet = {close_id: "gardiensforetCrossClose", div_id: "modal-expo-gardiens-foret"};
    addModalEvent(gardiensforet);
    const sage = {close_id: "sageCrossClose", div_id: "modal-expo-sage"};
    addModalEvent(sage);
    const creche = {close_id: "crecheCrossClose", div_id: "modal-expo-creche"};
    addModalEvent(creche);
    const loup = {close_id: "loupCrossClose", div_id: "modal-expo-loup"};
    addModalEvent(loup);
    const fumeur = {close_id: "fumeurCrossClose", div_id: "modal-expo-fumeur"};
    addModalEvent(fumeur);
    const damenature = {close_id: "damenatureCrossClose", div_id: "modal-expo-damenature"};
    addModalEvent(damenature);
    const dragon = {close_id: "dragonCrossClose", div_id: "modal-expo-dragon"};
    addModalEvent(dragon);
    const oursesaintghislain = {close_id: "oursesaintghislainCrossClose", div_id: "modal-expo-ourse-saint-ghislain"};
    addModalEvent(oursesaintghislain);

    function addModalEvent(modal) {
        const crossCloseEl = document.getElementById(modal.close_id);
        if (crossCloseEl) {
            crossCloseEl.addEventListener('click', (event) => {closeModalFunction(modal.div_id);});    
        }
    };

    function closeModalFunction(div_id) {
        const modal = document.getElementById(div_id);
        modal.style.display = 'none';
    }    
}

export default closeModal;